import React, { useEffect, useRef } from 'react';
import { scrollErorrElementInView } from './helperFns';

interface FormError {
  [key: string]: any;
}
/**
 * This hook is used to listen on errors and scroll to inputs containing erorr
 * @param formRef
 * @param errors
 * @returns
 */
export const useFormErrorListener = (
  formRef: React.RefObject<HTMLFormElement>,
  errors: FormError,
) => {
  const prevErrorsRef = useRef<FormError>({});

  useEffect(() => {
    const prevErrors = prevErrorsRef.current;

    const hasErrorsChanged = Object.keys(errors).some(
      key => errors[key] !== prevErrors[key],
    );

    if (hasErrorsChanged) {
      scrollErorrElementInView(formRef, errors);
    }

    prevErrorsRef.current = { ...errors };
  }, [errors]);

  return formRef;
};
